import React from 'react';
import './formatBar.css';

const FormatBar = ({ onFormatClick, activeFormats, showImageButton = false }) => {
  const handleFormat = (formatType) => {
    if (onFormatClick) {
      onFormatClick(formatType);
    }
  };

  return (
    <div className="format-bar">
      <button 
        className={`format-button ${activeFormats && activeFormats.heading ? 'active' : ''}`}
        onClick={() => handleFormat('heading')}
        title="Overskrift"
      >
        <span className="heading-icon">H</span>
      </button>
      <button 
        className={`format-button ${activeFormats && activeFormats.bold ? 'active' : ''}`}
        onClick={() => handleFormat('bold')}
        title="Fed tekst"
      >
        <strong>B</strong>
      </button>
      <button 
        className={`format-button ${activeFormats && activeFormats.italic ? 'active' : ''}`}
        onClick={() => handleFormat('italic')}
        title="Kursiv"
      >
        <em>I</em>
      </button>
      <button 
        className={`format-button ${activeFormats && activeFormats.underline ? 'active' : ''}`}
        onClick={() => handleFormat('underline')}
        title="Understreg"
      >
        <u>U</u>
      </button>
      <button 
        className={`format-button ${activeFormats && activeFormats.bullet ? 'active' : ''}`}
        onClick={() => handleFormat('bullet')}
        title="Punktopstilling"
      >
        • Liste
      </button>
      <button 
        className={`format-button ${activeFormats && activeFormats.link ? 'active' : ''}`}
        onClick={() => handleFormat('link')}
        title="Link"
      >
        🔗 Link
      </button>
      {showImageButton && (
        <button 
          className={`format-button ${activeFormats && activeFormats.image ? 'active' : ''}`}
          onClick={() => handleFormat('image')}
          title="Indsæt billede"
        >
          📷 Billede
        </button>
      )}
    </div>
  );
};

export default FormatBar;
